import React from 'react'
import injectStyles from 'react-jss'
import { STEPS, STEPS_LABELS } from '../options'
import { theme } from '../../../../Assets/Styles/theme'

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
    width: '264px',
  },

  stepWrapper: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  stepContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    position: 'relative',
    zIndex: 2,
  },
  circle: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '2px solid',
    fontSize: '12px',
    fontWeight: 'bold',
    position: 'relative',
    zIndex: 2,
  },
  connector: {
    width: '84px',
    height: '2px',
    transform: 'translateY(-50%)',
    zIndex: 1,
    position: 'absolute !important',
    top: '12px',
    left: '41px',
  },
  label: {
    fontSize: '16px',
    fontWeight: '500',
    textAlign: 'center',
    minWidth: '60px',
  },
  completed: {
    backgroundColor: theme.colors.primary,
    borderColor: theme.colors.primary,
    color: 'white',
  },
  active: {
    backgroundColor: 'white',
    borderColor: theme.colors.primary,
    color: theme.colors.primary,
  },
  inactive: {
    backgroundColor: 'white',
    borderColor: '#DFE2E5',
    color: '#DFE2E5',
  },
  'connector-completed': {
    backgroundColor: theme.colors.primary,
  },
  'connector-inactive': {
    background: '#DFE2E5',
  },
  'label-completed': {
    color: theme.colors.primary,
    textDecoration: 'line-through',
  },
  'label-active': {
    color: theme.colors.primary,
  },
  'label-inactive': {
    color: '#7F8FA4',
  },
}

const ProgressSteps = ({ currentStep, classes }) => {
  const stepsArray = Object.values(STEPS)

  const getStepStatus = stepKey => {
    const stepIndex = stepsArray.indexOf(stepKey)
    const currentIndex = stepsArray.indexOf(currentStep)

    if (stepIndex < currentIndex) {
      return 'completed'
    } else if (stepIndex === currentIndex) {
      return 'active'
    } else {
      return 'inactive'
    }
  }

  return (
    <div className={classes.container}>
      {stepsArray.map((step, index) => {
        const status = getStepStatus(step)
        const isLast = index === stepsArray.length - 1

        return (
          <div key={step} className={classes.stepWrapper}>
            <div className={classes.stepContent}>
              <div className={`${classes.circle} ${classes[status]}`} />

              <div className={`${classes.label} ${classes[`label-${status}`]}`}>
                {STEPS_LABELS[step]}
              </div>
            </div>
            {!isLast && (
              <div
                className={`${classes.connector} ${
                  classes[
                    status === 'completed'
                      ? 'connector-completed'
                      : 'connector-inactive'
                  ]
                }`}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}

export default injectStyles(styles)(ProgressSteps)
